import React, { useEffect, useState } from 'react';
import { IoChatbubble, IoChatbubbleOutline, IoPerson } from "react-icons/io5";
import { GoHome } from 'react-icons/go';
import SearchWithAnimation from '../../Shared components/SearchBarWithFilters';
import { useCookies } from 'react-cookie';
import { Filters } from '../../types/filter';
import Logo from '../../imgs/Logo.jpg';
import { Link, useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import Banner from '../../imgs/Otlob Banner cropped.jpg';

const Navbar = ({ onChange, onHomeClick }: { onChange: (value: Filters) => void, onHomeClick: () => void }) => {
    const [cookies, setCookie, removeCookie] = useCookies(['user-data', "token"]);
    const user = cookies["user-data"];
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
        removeCookie("user-data");
        removeCookie("token");
        navigate("/");
    };

    const handleContactUs = () => {
        navigate('/contact-us');
    };

    useEffect(() => {}, [cookies["user-data"]]);
    return (
        <nav className='w-full h-20 flex flex-row justify-between items-center px-5 relative'>
            <div className='flex flex-row justify-around items-center'>
                <div className='relative'>
                    <div
                        className='w-10 h-10 rounded-full flex items-center justify-center overflow-hidden cursor-pointer bg-gradient-to-b from-neutral-400 to-neutral-300' // Moved gradient to container
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                    >
                        {user?.image ? (
                            <img 
                                src={user.image} 
                                alt="User" 
                                className="w-full h-full object-cover" // Ensure image fills container
                            />
                        ) : (
                            <IoPerson size={25} color='#8e8e8e' />
                        )}
                    </div>
                    {dropdownOpen && (
                        <div className="absolute top-12 left-0 w-40 bg-white shadow-lg rounded-lg border z-50 text-right">
                            <Link
                                to={`/profile/${cookies["user-data"]?.id}`}
                                className="block px-4 py-2 hover:bg-gray-100"
                                onClick={() => setDropdownOpen(false)}
                            >
                                الحساب الشخصي
                            </Link>
                            <button
                                onClick={handleLogout}
                                className="block w-full text-red-100 px-4 py-2 hover:bg-gray-100 text-right"
                            >
                                تسجيل الخروج
                            </button>
                        </div>
                    )}
                </div>

                <div className='flex flex-row ml-4 md:ml-9 w-28 md:w-36 justify-between'>
                    {user.role === "trainee" ?
                        <Link to="/home" className="group relative" onClick={onHomeClick}>
                            <GoHome size={23} className="cursor-pointer text-black group-hover:hidden transition-all duration-200" />
                            <FaHome size={23} className="cursor-pointer text-primary-200 hidden group-hover:block transition-all duration-200" />
                        </Link> :
                        <Link to={`/profile/${user.id}`} className="group relative">
                            <GoHome size={23} className="cursor-pointer text-black group-hover:hidden transition-all duration-200" />
                            <FaHome size={23} className="cursor-pointer text-primary-200 hidden group-hover:block transition-all duration-200" />
                        </Link>
                    }
                    <Link to="/chat" className="group relative">
                        <IoChatbubbleOutline size={23} className="cursor-pointer text-gray-700 group-hover:hidden transition-all duration-200" />
                        <IoChatbubble size={23} className="cursor-pointer text-primary-200 hidden group-hover:block transition-all duration-200" />
                    </Link>
                    <SearchWithAnimation onChange={onChange} />
                </div>
            </div>

            <div className="hidden md:block">
                <img
                    src={Banner}
                    alt="Otlob Banner"
                    className="h-16 w-auto object-contain"
                />
            </div>
            <div className='flex flex-row justify-around items-center gap-4'>
                {/* Contact Us Button */}
                <button
                    onClick={handleContactUs}
                    className='bg-primary-200 text-white px-4 py-2 rounded-lg hover:bg-primary-300 transition duration-200'
                >
                    تواصل معنا
                </button>

                <div className='w-10 h-10'>
                    <img src={Logo} alt="Otlob Coach" className="w-full h-full object-contain" />
                </div>
            </div>
        </nav>
    );
};

export default Navbar;